'use client'

import { useContext } from 'react'

import { Cell, Image, Text, Label, Card, Icon, Spacer } from '@vinted/web-ui'
import { Home24, Printer16 } from '@vinted/monochrome-icons'

import { GetShippingLabelContext } from '@marketplace-web/shipping-services-provider/shipping-services-provider-feature'
import {
  DropOffTypeKey,
  DropOffsPointType,
} from '@marketplace-web/conversation-shipping/conversation-shipping-data'

import { useTranslate } from '@marketplace-web/shared/i18n'

const ShippingMethod = () => {
  const translate = useTranslate('conversation.get_shipping_label.modal')
  const {
    state: {
      labelOptions: { labelOptions },
      dropOffPointTypeSelection: { selectedDropOffPointType },
    },
  } = useContext(GetShippingLabelContext)

  const labelOptionDropOffType = labelOptions?.dropOffTypes?.[0]?.key

  const hasShippingMethodData =
    labelOptionDropOffType === DropOffTypeKey.Home2Home ||
    labelOptionDropOffType === DropOffTypeKey.ContactlessDropoff

  const labelOptionsDropOffs = labelOptions?.dropOffs
  const isHomePickupSelected = selectedDropOffPointType === DropOffsPointType.Home

  const shouldShowShippingData =
    hasShippingMethodData ||
    isHomePickupSelected ||
    (labelOptionsDropOffs &&
      labelOptionsDropOffs.length === 1 &&
      labelOptionsDropOffs[0]?.type === DropOffsPointType.Home)

  if (!shouldShowShippingData) return null

  const iconUrl = labelOptions?.dropOffTypes?.[0]?.dropOffTypeMeta.printIcon?.url
  const shippingMethodInfo = labelOptions?.dropOffTypes?.[0]?.dropOffTypeMeta.printIcon?.text
  const titleText = hasShippingMethodData
    ? translate('shipping_method.title')
    : translate('home_shipping_method.title')
  const bodyText = hasShippingMethodData
    ? translate('shipping_method.body')
    : translate('home_shipping_method.body')

  const printerRequirementText =
    shippingMethodInfo || translate('home_shipping_method.printer_requirement')

  const renderPrinterRequirement = () => {
    if (hasShippingMethodData) {
      return (
        <div className="u-inline-flex">
          <Image src={iconUrl} size={Image.Size.Small} />
          <Spacer orientation={Spacer.Orientation.Vertical} />
          <Text as="h3" type={Text.Type.Caption} text={printerRequirementText} />
        </div>
      )
    }

    return (
      <div className="u-flexbox">
        <Icon name={Printer16} />
        <Spacer orientation={Spacer.Orientation.Vertical} />
        <Text as="h3" type={Text.Type.Caption} text={printerRequirementText} />
      </div>
    )
  }

  return (
    <>
      <Label type={Label.Type.Stacked} text={translate('shipping_method.label')} />
      <Cell testId="generate-label-modal-shipping-method">
        <Card>
          <Cell theme="transparent">
            <div className="u-flexbox u-flex-direction-column">
              <Icon name={Home24} />
              <Spacer />
              <Text as="h2" type={Text.Type.Title} text={titleText} />
              <Text as="span" text={bodyText} />
            </div>
            <Spacer />
            {renderPrinterRequirement()}
          </Cell>
        </Card>
      </Cell>
    </>
  )
}

export default ShippingMethod
